var e,o="undefined"!=typeof window,n=function(){return void 0===e&&(e=!o&&"undefined"!=typeof global&&(global.process&&"server"===global.process.env.VUE_ENV)),e};export{n as isServerRendering};
